module.exports = __webpack_public_path__ + "burger.svg?434aed855a5dfcf6e63062c6b778e03f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/burger.svg
// module id = 369
// module chunks = 0